import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {PredictionsWidgetController} from "../predictions-widget.controller";

export class PredictionsWidgetProps extends BaseModuleProps {
  controller: PredictionsWidgetController;
}
